export type FormatStringArg = string | number;

export function formatString(input: string, ...args: FormatStringArg[]): string {
  return input.replace(/{(\d+)}/g, (match, number) => {
    const value = args[number];
    if (typeof value === 'undefined') {
      return match;
    }

    if (typeof value !== 'string' && typeof value !== 'number') {
      throw new TypeError('formatString only accepts string and number arguments.');
    }

    return String(value);
  });
}
